import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { format, parseISO } from "date-fns";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CatalogItemRow } from "../catalogItems.types";

export const LastUpdatedCell = memo(function LastUpdatedCell({
    row,
}: CellContext<ViewTableFeatures, CatalogItemRow, unknown>) {
    const item = row.original;
    if (item.isNew) {
        return <ViewTableCell />;
    }
    // Typed as Date but arrives as an ISO string over the wire.
    const date =
        typeof item.updatedAt === "string"
            ? parseISO(item.updatedAt)
            : item.updatedAt;
    const label = Number.isNaN(date.getTime())
        ? ""
        : format(date, "MMM d, yyyy");
    return <ViewTableCell>{label}</ViewTableCell>;
});
